forms-teams-save  
  form.form(action="{ opts.action }" method="{ opts.method }" onSubmit="{ this.onSubmit }")
    inputs-hidden(tag-scope="{ this.tagScope }.inputs.method")
    inputs-hidden(tag-scope="{ this.tagScope }.inputs.authenticity_token")
    inputs-textfield(tag-scope="{ this.tagScope }.inputs.name")
    inputs-textfield(tag-scope="{ this.tagScope }.inputs.name_alt")
    inputs-radio-multiple(tag-scope="{ this.tagScope }.inputs.role")
    inputs-typeahead-multiple(tag-scope="{ this.tagScope }.inputs.users" )
    inputs-submit(tag-scope="{ this.tagScope }.inputs.submit")
  script(type="typescript").
    this.mixin('forms.teams.save')
